import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbModalModule, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from '@angular/forms';
import {TooltipModule} from 'primeng/primeng';
import {DataTablesModule} from 'angular-datatables';
import {IncomingComponent} from './incoming/incoming.component';
import {OutgoingComponent} from './outgoing/outgoing.component';


@NgModule({
    imports: [CommonModule, NgbModalModule, FormsModule, TooltipModule, DataTablesModule, NgbModule],
    declarations: [ IncomingComponent, OutgoingComponent ]
})
export class ApplicationFormOiaModule { }
